module.exports = __webpack_public_path__ + "img/dan2.8e8dd51c.png";